import { render, staticRenderFns } from "./TransferirEscrituracoes.vue?vue&type=template&id=d9ac2962&scoped=true&"
import script from "./TransferirEscrituracoes.vue?vue&type=script&lang=js&"
export * from "./TransferirEscrituracoes.vue?vue&type=script&lang=js&"
import style0 from "./TransferirEscrituracoes.vue?vue&type=style&index=0&id=d9ac2962&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9ac2962",
  null
  
)

export default component.exports